import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, input } from '@angular/core';
import { ISidebarNavItem, SidebarMenuComponent } from '../../components/sidebar-menu';

@Component({
  selector: 'cm-admin-layout',
  standalone: true,
  imports: [CdkScrollable, SidebarMenuComponent],
  templateUrl: './admin.layout.html',
  styleUrl: './admin.layout.less',
})
export class AdminLayout {
  public readonly navItems = input.required<ISidebarNavItem[]>();
  public readonly hasSidebarMenu = input<boolean>(true);
  public readonly headerIcon = input<string>('admin_panel_settings');
  public readonly headerTitle = input<string>('Admin Settings');
  /** When true, the content wrapper spans the full available width (no max-width cap). */
  public readonly fullWidth = input<boolean>(false);
}
